export const selectEndpointOverrideUrl = (layoutData: any) =>
  layoutData.settings?.data?.api?.endpoint
